import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';

import { environment } from '../../environments/environment';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
    providedIn: 'root'
})
export class GeneralService {
    private environmentSetted$: BehaviorSubject<boolean>;

    objetoEmail: any = {
        CodTipoCorreo: String,
        idUnidad: Number,
        Campos: [],
        Adjuntos: []
    };

    constructor(
        private http: HttpClient
    ) {
        this.environmentSetted$ = new BehaviorSubject(false);
    }

    private urlSource = new BehaviorSubject<string>('/home');
    currentUrl = this.urlSource.asObservable();

    public changeUrl(value: string) {
        this.urlSource.next(value);
    }

    
    variablesEntorno() {
        return new Promise((resolve, reject) => {
            this.http.get('assets/app/configuracion.txt').subscribe( data => {
                resolve(data)
            })
        })
    }

    getEnvironmentSetted() {
        return this.environmentSetted$;
    }

    environmentSetted(value: boolean) {
        this.environmentSetted$.next(value);
    }

    parametros() {
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.path}${environment.service.parametrosConfiguracion.endpoint}`).subscribe( data => {
                resolve(data);
            })
        })

    }

    unidades(idIdioma) {

        return new Promise((resolve, reject) => {
            this.http.get(`${environment.path}${environment.service.unidades.endpoint}?idIdioma=${idIdioma}`).subscribe( data => {
                resolve(data);
            })
        })

    }

    unidadesOtros(idIdioma) {

        return new Promise((resolve, reject) => {
            this.http.get(`${environment.path}${environment.service.unidadesOtros.endpoint}?idIdioma=${idIdioma}`).subscribe( data => {
                resolve(data);
            })
        })

    }

    redesSociales(idUnidad: number) {
        return this.http.get(`${environment.path}${environment.service.redesSociales.endpoint}?idUnidad=${idUnidad}`);
    }

    canales() {
        //console.log("url: " + `${environment.pathMotor}${environment.service.canales.endpoint}`);
        return this.http.get(`${environment.pathMotor}${environment.service.canales.endpoint}`);
    }

    selectListForm(idIdioma) {
        return this.http.get(`${environment.path}${environment.service.listaSelectFormulario.endpoint}?idIdioma=${idIdioma}`);
    }


    etiquetasFooter(idIdioma) {
        return this.http.get(`${environment.path}${environment.service.etiquetasFooter.endpoint}?idIdioma=${idIdioma}`);
    }

    contenidoFormularioCotizacion(idUnidad: number, idIdioma: number) {
        return this.http.get(`${environment.path}${environment.service.contenidoFormularioCotizacion.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`)
    }

    filterCategorias(idIdioma: number) {
        return this.http.get(`${environment.path}${environment.service.filterCategorias.endpoint}?idIdioma=${idIdioma}`);
    }

    enviarCorreo(objectSendEmails) {
        console.log("Ruta: " + environment.path);
        //return this.http.post(`http://localhost:5000/api/cms/Transversal/Correo/Enviar`, objectSendEmails, httpOptions);
        return this.http.post(`${environment.path}${environment.service.notificacionEmail.endpoint}`, objectSendEmails, httpOptions);

    }
    
    clearObjetEmail() {

        this.objetoEmail['Campos'] = [];
        this.objetoEmail['Adjuntos'] = [];
    }

    clonaCampoFormulario = formulario => {
        return {
            ...formulario
        };
    }

    generaObjetoEmail(tipoEmail) {
        this.objetoEmail.CodTipoCorreo = tipoEmail;
        return this.objetoEmail;
    }

    generaObjetoIdUnidad(idUnidad) {
        this.objetoEmail.idUnidad = idUnidad;
        return this.objetoEmail;
    }

    preparaParamsEnvioEmail(objetoCorreo: any = {}) {
        // tslint:disable-next-line: forin
        
        for (const prop in objetoCorreo) {
            if (prop === 'Adjunto') {
                this.setArchivoAdjunto(objetoCorreo[prop]);
            } else {
                if (prop !== 'file') {
                    let prop1 = prop;
                    if (prop === 'email') {
                        prop1 = 'EMail';
                    }
                    if (this.objetoEmail.CodTipoCorreo === 'PRO') {
                        prop1 = this.cambiaNombreCampoPRO(prop1);
                    } else if (this.objetoEmail.CodTipoCorreo === 'NEG' || this.objetoEmail.CodTipoCorreo === 'EVE') {
                        prop1 = this.cambiaNombreCampoNEG(prop1);
                    } else if (this.objetoEmail.CodTipoCorreo === 'GAS') {
                        prop1 = this.cambiaNombreCampoGAS(prop1);
                    } else {
                        prop1 = this.primeraLetra(prop1);
                    }
                    this.objetoEmail.Campos.push({
                        'Nombre': this.primeraLetra(prop1),
                        'Valor': objetoCorreo[prop]
                    });
                } else {

                }
            }
        }
        
        return this.objetoEmail;
    }

    setArchivoAdjunto(objetoAdjunto) {
        this.objetoEmail.Adjuntos.push(objetoAdjunto);

    }

    converBooleanToNameUnidad(Unidades: any = [], UnidadSeleccionada: any = []) {
        let unidadSelect = '';
        Unidades.forEach((element, index) => {
            const posicion = index;
            if (UnidadSeleccionada[posicion]) {
                unidadSelect += element.nombre + ', ';
            }
        });
        unidadSelect = unidadSelect.substring(0, unidadSelect.length - 2)
        return unidadSelect;
    }

    primeraLetra(text) {
        if (text !== 'EMail') {
            return text.charAt(0).toUpperCase() + text.slice(1);
        } else {
            return text;
        }
    }

    cambiaNombreCampoPRO(prop) {
        switch (prop) {
            case 'nombre':
                return 'NombreEmpresa';

            case 'rut':
                return 'RutEmpresa';

            case 'contacto':
                return 'NumeroContacto';

            case 'infComercial':
                return 'Categoria';

            default:
                return prop;

        }
    }

    cambiaNombreCampoGAS(prop) {

        switch (prop) {
            case 'cantidad':
                return 'CantidadPersonas';

            case 'categoria':
                return 'CategoriaSocio';

            case 'hora':
                return 'Horario';
            default:
                return prop;

        }
    }

    cambiaNombreCampoNEG(prop) {
        switch (prop) {
            case 'nombre':
                return 'Nombre';
            case 'apellidos':
                return 'Apellidos';
            case 'rut':
                return 'Rut';
            case 'Contacto':
                return 'NumeroContacto';
            case 'InfComercial':
                return 'Categoria';

            default:
                return prop;
        }
    }

    listaCategorias(params: any) {
        return this.http.get(`${environment.path}${environment.service.listaCategorias.endpoint}`, { params: params });
    }

    FechaFormatoDMY(fecha: any) {
        const fechaSeleccionada = new Date(fecha)
        const anno = this.digitMenor10(fechaSeleccionada.getFullYear());
        const mes = this.digitMenor10((fechaSeleccionada.getMonth() + 1));
        const dia = this.digitMenor10(fechaSeleccionada.getDate());
        return dia + '-' + mes + '-' + anno;
    }

    digitMenor10 = (digito) => {
        if ((digito * 1) < 10) {
            return '0' + digito;
        } else {
            return digito;
        }
    }

    modalService(idUnidad,idIdioma){
        return this.http.get(`${environment.path}${environment.service.modal.endpoint}/${idUnidad}/${idIdioma}`);

    }

    freeLayout(contentId: any) {
        const url = `${environment.path}/crm.freelayout/api/FreeLayout/0/0/${contentId}`;
        return this.http.get(url).pipe(
            tap((response: any) => {
                let valid: boolean = true;
                if (response.codigo !== 1) { valid = false }
                else if (isNullOrUndefined(response.data) || response.data.length === 0) { valid = false; }

                if (!valid) { throw new Error('no se consiguió layout'); }
            }),
            map((response: any) => response.data[0])
        );
    }

    dynamicContent(contentId: any, idIdioma:any) {
        return this.http.get(`${environment.path}/crm.freelayout/api/FreeLayoutIdioma/0/${idIdioma}/${contentId}`);
     //   return this.http.get(`/assets/${contentId}.html`,{ responseType: 'text' });
    }
}

